<template>
  <transition name="snackbar">
    <div
      v-if="snackbar.isShown.value"
      class="pointer-events-auto fixed right-24 top-3 flex items-center gap-3 rounded-lg px-2 py-1 text-lg border z-100"
      :class="
        snackbar.state.value === SnackbarState.SUCCESS
          ? 'border-green-500 bg-green-50 text-green-600'
          : 'border-red-500 bg-red-50 text-red-600'
      "
    >
      <div class="relative">
        <div
          class="absolute ping-limited size-full rounded-full top-0 left-0"
          :class="
            snackbar.state.value === SnackbarState.SUCCESS
              ? 'bg-green-300'
              : 'bg-red-300'
          "
        ></div>

        <component
          :is="
            snackbar.state.value === SnackbarState.SUCCESS
              ? CheckCircleIcon
              : ExclamationCircleIcon
          "
          class="size-8 relative z-10"
        />
      </div>

      <span class="font-medium">
        {{ snackbar.content.value }}
      </span>

      <button class="ml-4" @click="snackbar.hide">
        <XMarkIcon class="size-6" />
      </button>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import useSnackbar from '@app/composables/use-snackbar'
import { SnackbarState } from '@app/types'
import {
  CheckCircleIcon,
  XMarkIcon,
  ExclamationCircleIcon,
} from '@heroicons/vue/20/solid'

const snackbar = useSnackbar()
</script>
<style scoped>
.snackbar-enter-active {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.snackbar-leave-active {
  transition: transform 0.3s ease-in;
}

.snackbar-enter-from {
  transform: translateX(calc(100vw - 5rem));
}

.snackbar-leave-to {
  transform: translateX(calc(100vw - 5rem));
}

.snackbar-enter-to,
.snackbar-leave-from {
  transform: translateX(0);
}
</style>
